import * as turf from "@turf/turf";

import { getName, sendToast } from "../components/util";
import { Layer } from "../App";

const getSchema = (layers: Layer[]) => {
  const layerEnum = layers.map(l => ({ key: l._id, value: getName(l) }));
  return {
    type: "object",
    title: "Intersect current polygon with another polygon.",
    properties: {
      poly2: {
        type: "string",
        title: "Other polygon",
        enum: layerEnum
      }
    }
  };
};

const ui = {};

interface Props {
  addLayer: Function;
  layer: Layer;
  formData: any;
  handleClose: Function;
  layers: Layer[];
}

const validGeojson = (i: any) => {
  return i && i.type;
};

const fn = (props: Props) => {
  const { addLayer, layer, formData, handleClose, layers } = props;
  const { poly2 } = formData;
  const otherPoly = layers.find(l => l._id === poly2);
  try {
    const i = turf.intersect(layer as any, otherPoly);
    if (validGeojson(i)) {
      addLayer({
        layer: i,
        name: `Intersection of ${getName(layer)} and ${getName(otherPoly)}`
      });
      handleClose();
    } else {
      sendToast("Cannot perform intersection");
    }
  } catch (e) {
    sendToast("Cannot perform intersection");
  }
};

export const getIntersectForm = (layers: Layer[]) => {
  const initial = { poly2: layers.length > 0 ? layers[0]._id : "" };
  return { schema: getSchema(layers), ui, fn, initial };
};
